import { render, staticRenderFns } from "./TowelAdmin.vue?vue&type=template&id=8a6f16c4&scoped=true"
import script from "./TowelAdmin.vue?vue&type=script&lang=js"
export * from "./TowelAdmin.vue?vue&type=script&lang=js"
import style0 from "./TowelAdmin.vue?vue&type=style&index=0&id=8a6f16c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a6f16c4",
  null
  
)

export default component.exports